// assets/deal-date.js
document.addEventListener('DOMContentLoaded', function () {
  function startCountdown(block) {
    const end = block.getAttribute('data-end-time');
    if (!end) return;

    // Expecting date string YYYY-MM-DD (midnight end). Adjust as needed.
    let endTime;
        if (end.includes('T')) {
        // already has time
        endTime = new Date(end).getTime();
        } else {
        // only date, add end of day time
        endTime = new Date(end + 'T23:59:59').getTime();
        }


    const daysEl = block.querySelector('.deal-days');
    const hoursEl = block.querySelector('.deal-hours');
    const minutesEl = block.querySelector('.deal-minutes');
    const secondsEl = block.querySelector('.deal-seconds');

    function update() {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        // Option: replace content or hide
        block.innerHTML = '<span class="deal-ended">Deal Ended</span>';
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = days;
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    block._dealInterval = setInterval(update, 1000);
  }

  document.querySelectorAll('.deal-date-block').forEach(function (el) {
    startCountdown(el);
  });
});
